import { DrawingPrizeType } from 'types/IDrawingSummary';
import type { PrizeType } from 'types/IPrize';
import { formatCurrencyEuro } from './formatCurrency';

export const prizeLabel = (typ: DrawingPrizeType | PrizeType, value: string, title: string | null): string =>
  typ === DrawingPrizeType.GELDGEWINN ? formatCurrencyEuro(value) : (title ?? 'Keine Angabe');
